<template>
  <div>
    <div class="footer_amidvw">
      <div class="footer_ami1">
        <div class="footer_amil">
          <div class="footer_amil_logo">
            <img src="@/assets/img/footer_amil_logo_01.webp" alt="">
          </div>
          <div class="footer_amil_googleplay">
            <div class="footer_amil_googleplay_1">
              <a
                      href="https://play.google.com/store/apps/details?id=com.amigocredi.loan"
                      target="_blank"
                      class="playBtn"
              >
              <img src="@/assets/img/footer_googleplay.webp" alt="">
              </a>
            </div>
          </div>
        </div>
        <div class="footer_amic">
          <div class="footer_amic_s"></div>
        </div>
        <div class="footer_amir">
          <div class="footer_amir_v">
            <div class="footer_amir_vt">Sobre Nosotros</div>
            <div class="footer_amir_vp" @click.stop="goAbount">Introducción de la Empresa</div>
          </div>
          <div class="footer_amir_v">
            <div class="footer_amir_vt">Garantías de Seguridad</div>
            <div class="footer_amir_vp" @click.stop="goP">Aviso de Privacidad</div>
            <div class="footer_amir_vp" @click="goT">Términos y Condiciones</div>
          </div>
          <div class="footer_amir_v">
            <div class="footer_amir_vt">Contáctanos</div>
            <div class="footer_amir_vp">Atención al clientes</div>
            <div class="footer_amir_vp">525585265083</div>
            <div class="footer_amir_vp">Correo electrónico</div>
            <div class="footer_amir_vp">amigocredi.contacto@gmail.com</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "./scss/foot.scss";

export default {
  name: "footPage",
  data() {
    return {};
  },
  methods: {
    goFacebook() {
      window.location.href = 'https://www.facebook.com/profile.php?id=61576050817729';
    },
    goInstagram() {
      window.location.href = 'https://www.instagram.com/arrecredi_atc/'
    },
    openGooglePlayLink() {
      //console.log('googleplay')
      window.location.href = 'https://app.adjust.com/1o8iv5h7';
    },
    goAbount(){
      this.$router.push({
        path: '/empresa'
      })
    },
    goP(){
      this.$router.push({
        path: '/privacy'
      })
    },
    goT(){
      this.$router.push({
        path: '/protocolo'
      })
    },
    goLink(type) {
      this.$router.push({
        path: '/loan',
        query: {
          activeName: type
        }
      })
    }
  }
};
</script>

<style lang="scss">
  .footer_amidvw{
    width: 100%;
    height: auto;
    background: #0F0000;
    .footer_ami1{
      width: 1440px;
      height: 323px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      .footer_amil{
        width: 466px;
        height: 323px;
        box-sizing: border-box;
        padding: 0 0 0 36px;
        .footer_amil_logo{
          width: 269px;
          height: 144px;
          img {
            display: block;
            width: 100%;
            height: 144px;
          }
        }
        .footer_amil_googleplay{
          width: 100%;
          height: 41px;
          position: relative;
          .footer_amil_googleplay_1{
            width: 128px;
            height: 50px;
            position: absolute;
            left: 47px;
            top: -9px;
            img {
              display: block;
              width: 100%;
              height: 50px;
            }
          }
        }
      }
      .footer_amic{
        width: 233px;
        height: 323px;
        box-sizing: border-box;
        padding: 48px 0 0 0;
        .footer_amic_s{
          width: 1px;
          height: 140px;
          background: #606265;
        }
      }
      .footer_amir{
        width: 789px;
        height: 323px;
        box-sizing: border-box;
        padding: 48px 84px 0 0;
        display: flex;
        justify-content: space-between;
        .footer_amir_v{
          width: 100%;
          height: auto;
          .footer_amir_vt{
            width: 100%;
            height: 60px;
            font-weight: bold;
            font-size: 20px;
            color: #FFFFFF;
            line-height: 20px;
            text-align: left;
            font-style: normal;
          }
          .footer_amir_vp{
            width: 100%;
            height: 38px;
            font-weight: 400;
            font-size: 14px;
            color: #FFFFFF;
            line-height: 14px;
            text-align: left;
            font-style: normal;
            cursor: pointer;
          }
        }
      }
    }
  }
</style>
